import { HYDRATE } from 'next-redux-wrapper';

import { THydrateAction } from '~/src/store';
import { PLANK_IS_HIDDEN, PLANK_IS_SHOWN, PLANK_MOBILE_LINK_AND_TYPE } from '~/src/store/actionTypes/plank';

interface IMobileLinkAndType {
    mobileLink: null | string,
    plankType?: {
        headerText: string,
        text: string,
        href: string,
        linkName: string,
        pic: string,
        domain: string,
    },
}

export interface IPlank extends IMobileLinkAndType {
    isShows: boolean,
}

const initialState: IPlank = {
    isShows: true,
    mobileLink: 'https://app.dom.ru/open',
};

type TSetPlankIsShown = {
    type: typeof PLANK_IS_SHOWN,
}

type TSetPlankIsHidden = {
    type: typeof PLANK_IS_HIDDEN,
}

type TSetMobileLinkAndType = {
    type: typeof PLANK_MOBILE_LINK_AND_TYPE,
    payload: IMobileLinkAndType,
}

type TActions = TSetMobileLinkAndType | TSetPlankIsHidden | TSetPlankIsShown | THydrateAction;

export default (state = initialState, action: TActions) => {
    switch (action.type) {
        case HYDRATE:
            return {
                ...state,
                ...action.payload.plank,
            };
        case PLANK_MOBILE_LINK_AND_TYPE:
            return {
                ...state,
                mobileLink: action.payload.mobileLink,
                plankType: action.payload.plankType,
            };
        case PLANK_IS_SHOWN: {
            return {
                ...state,
                isShows: true,
            };
        }
        case PLANK_IS_HIDDEN: {
            return {
                ...state,
                isShows: false,
            };
        }
        default: {
            return state;
        }
    }
};
